// extracted by mini-css-extract-plugin
export default {"disabled":"Link_disabled__-TP4k","enabled":"Link_enabled__h2oLe","link":"Link_link__EUF1t"};